module.exports = __webpack_public_path__ + "img/btn2.4c38a48c.png";